import { CheckIcon, EditIcon } from "fe-shared/src/components/Icons";
import { PermissionLevel } from "fe-shared/src/types/domain";
import {
  CorrectionsActionConfig,
  CorrectionsAction,
  TransactionStatus,
  TransactionType,
  CorrectionMaterial,
} from "fe-shared-transactions/src/types";
import { PERMISSIONS } from "consts";

const { Submit, EditTransaction } = CorrectionsAction;

const { InReview, Suspended } = TransactionStatus;

export const actions: CorrectionsActionConfig[] = [
  {
    name: EditTransaction,
    isVisible: (t) =>
      t.statusCode === InReview &&
      t.transactionType !== TransactionType.Disposition,
    hasConfirmationDialog: true,
    buttonProps: {
      iconComponent: EditIcon,
    },
    permission: {
      name: PERMISSIONS.transactionCorrect,
      level: PermissionLevel.Full,
    },
  },
  {
    name: Submit,
    isVisible: (t, c) =>
      [Suspended].includes(t.statusCode) &&
      !!c.lastModifiedBy &&
      !c.isSubmitted,
    hasConfirmationDialog: false,
    buttonProps: {
      iconComponent: CheckIcon,
    },
    permission: {
      name: PERMISSIONS.transactionCorrectionSubmit,
      level: PermissionLevel.Full,
    },
  },
];

export const isTransactionLoadChanged = (
  originalMaterials: CorrectionMaterial[],
  updatedMaterials?: CorrectionMaterial[]
) =>
  (updatedMaterials !== undefined &&
    originalMaterials?.length !== updatedMaterials?.length) || // adjustment case
  updatedMaterials?.some((um) => {
    const transactionMaterial = originalMaterials.find(
      (om) => um.materialCode === om.materialCode
    );

    return (
      !transactionMaterial ||
      transactionMaterial.units.unitQuantity !== um.units.unitQuantity
    );
  });

export default actions;
